import React from "react";
import { RaisedButton, RadioButtonGroup, RadioButton } from "material-ui";
import { Link } from "react-router";
import qs from "qs";
import moment from "moment";

import config from "../config";
import Label from "./partials/label.jsx";
import InjectedSelect from "./partials/injected-select.jsx";
import InfoNotice from "./partials/info-notice.jsx";

import UserStore from "../stores/UserStore";

class BallotingPrint extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      target: "all",
      selected: []
    };

    this.getPDFUrl = this.getPDFUrl.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object
  };

  getStyles() {
    return {
      radio: {
        marginBottom: "1em"
      },
      actions: {
        marginTop: "1.5em"
      }
    };
  }

  getPDFUrl() {
    const query = {
      event_bucket: this.props.eventBucket.id,
      events: this.state.target === "specific" ? this.state.selected : undefined
    };
    return `${
      config.endpoint
    }ballots/ballot.pdf?${UserStore.makeApiKeyQueryString()}&${qs.stringify(
      query
    )}`;
  }

  render() {
    const styles = this.getStyles(),
      { eventBucket } = this.props;

    return (
      <div>
        <p>
          Instead of (or in addition to) mobile ballots, you can also collect
          paper ballots.
          <br />
          Select desired print options and then click "Print ballots" to
          generate a printable PDF.
        </p>
        <InfoNotice style={{ marginBottom: "1em", fontSize: "10pt" }}>
          Check out our{" "}
          <a
            href="https://help.eventive.org/eventive-balloting/generating-paper-ballots"
            target="_blank"
          >
            guide to printing ballots
          </a>
          .
        </InfoNotice>
        <Label>Ballots to print</Label>
        <div>
          <RadioButtonGroup
            style={styles.radio}
            name="tabulation_method"
            valueSelected={this.state.target}
            onChange={(e, v) => this.setState({ target: v })}
          >
            <RadioButton
              value="all"
              label={`All ballots for ${eventBucket.name}`}
            />
            <RadioButton value="specific" label="Ballots for specific events" />
          </RadioButtonGroup>
        </div>
        {this.state.target === "specific" ? (
          <div style={{ maxWidth: 600 }}>
            <InjectedSelect
              value={this.state.selected}
              label="Events"
              labelFormatter={e =>
                `${e.name} – ${moment(e.start_time).format("lll")}`
              }
              type="events"
              eventBucketId={eventBucket.id}
              multi={true}
              onChange={v => this.setState({ selected: v })}
            />
          </div>
        ) : null}
        <div style={styles.actions}>
          <RaisedButton
            label="Print ballots"
            primary
            href={this.getPDFUrl()}
            target="_blank"
          />
        </div>
      </div>
    );
  }
}

export default BallotingPrint;



// WEBPACK FOOTER //
// ./src/app/components/balloting-print.jsx